import MapboxClient from 'mapbox';
import * as _ from 'lodash'
import axios from 'axios';
import config from '../constants/config';
import { meterToMailes, withQuery } from '.';

import { multiLineString, lineString, Feature } from '@turf/helpers';

const instanceMapClient = new MapboxClient(config.keyMapBox);


export interface LocationT {
    latitude: number
    longitude: number
}

const mapboxOptions = {
    api: "https://api.mapbox.com/geocoding/v5",
}


interface RestultDirectionsT {
    steps: Array<any>
    globalRoute: Feature
    detailedRoute: Feature
    duration: number
    distance: number
    distanceMailes: number
    instruction: string
}


export const getDirections = async (locations: Array<LocationT>): Promise<RestultDirectionsT> => {

    try {
        const res = await instanceMapClient.getDirections(
            locations,
            { profile: "driving", geometry: "polyline6", steps: true },
        );
        // console.log("getDirections", res)
        if (res && _.has(res, "entity.routes") && _.isArray(res.entity.routes)) {

            const routeData = res.entity.routes[0];

            const steps = routeData.legs[0].steps.map(step => step.geometry.coordinates);
            // meterToMailes
            let result = {
                steps: routeData.legs[0].steps,
                globalRoute: lineString(routeData.geometry.coordinates),
                detailedRoute: multiLineString(steps),
                duration: routeData.duration,
                distance: routeData.distance,
                distanceMailes: meterToMailes(routeData.distance),
                instruction: routeData.legs[0].summary,

            };
            // console.log("getDirections", result)
            return result;
        }

        throw new Error("Unknown error occurred");
    } catch (err) {
        console.log("error: " + err);
        throw new Error(err);
    }
};

export const getDetailsAddress = async (search, accessToken) => {
    const params = {
        access_token: accessToken,
        query: {
            country: "us",
        },
    }
    const url = `${mapboxOptions.api}/mapbox.places/${search}.json`
    return axios.get(withQuery(url, params)).then((res) => {
        console.log("res", res)
        return res;
        // if (res.data && res.data.features && res.data.features) {
        //     return res.data.features
        // }
    })
}



export default instanceMapClient;